import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsRowProps {
  item: NewsItem;
}

function blockStyle(category: NewsItem["category"]) {
  switch (category) {
    case "作品资讯":
      return "bg-primary-100 text-primary-800";
    case "人物动态":
      return "bg-accent-100 text-accent-900";
    case "行业观察":
      return "bg-secondary-100 text-secondary-900";
    default:
      return "bg-background-200 text-foreground-700";
  }
}

export default function NewsRow({ item }: NewsRowProps) {
  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex items-start gap-4 border-b border-background-200 py-4 last:border-b-0"
    >
      <span className="hidden w-16 shrink-0 flex-col items-center border-r border-background-200 pr-3 text-center sm:flex">
        <span className="font-heading text-xl font-black leading-none text-primary-700">
          {item.date.slice(8, 10)}
        </span>
        <span className="mt-1 font-label text-[10px] text-foreground-500">{item.date.slice(0, 7)}</span>
      </span>
      <span className="min-w-0 flex-1">
        <span className="mb-1 flex flex-wrap items-center gap-2">
          <span className={`rounded px-1.5 py-0.5 font-label text-[10px] ${blockStyle(item.category)}`}>
            {item.category}
          </span>
          <span className="font-label text-[11px] text-foreground-400 sm:hidden">{item.date}</span>
        </span>
        <span className="block font-heading text-[15px] font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
          {item.title}
        </span>
        <span className="clamp-2 mt-1 block text-sm leading-relaxed text-foreground-600">{item.summary}</span>
      </span>
      <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500">
        <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
      </span>
    </Link>
  );
}